import React, { useState, useEffect, useRef } from 'react';
import { useForm, Controller } from 'react-hook-form';
import {
    GlobalContainer,
    ContentContainer,
    TitleContainer,
    Title,
    Subtitle,
    Line,
    SearchContainer,
    SelectContainer,
    SelectPagesContainer,
    InputContainer,
    SearchButtonsContainer,
    PaginationContainer,
} from './styles';
import Select, { components } from 'react-select';
import ModalCancel from '../Modal/Cancel/index';
import DropDownIcon from '../../assets/drop_down_icon.png';
import DropUpIcon from '../../assets/drop_up_icon.png';
import DropRightIcon from '../../assets/drop_right_icon.png';
import DropLeftIcon from '../../assets/drop_left_icon.png';
import FailIcon from '../../assets/fail_icon.png';
import ViewIcon from '../../assets/eye_icon.png';
import EditIcon from '../../assets/edit_icon.png';
import UndoIcon from '../../assets/undo_icon.png';
import DiscreditIcon from '../../assets/close_alert_icon.png';
import FilterIcon from '../../assets/filter_icon.png';
import AlertIcon from '../../assets/alert_icon2.png';
import ModalWarn from '../Modal/Warn/index';
import MessageSuccess from '../Messages/Success/index';
import { useLocation } from 'react-router-dom';
import { statusOrgaoEnum, agencyScopeEnum, estados } from '../../constants'
import { formatDateDDMMYYYY } from '../../utils';
import ModalConfirm from '../Modal/Confirm/index';
import ModalConfirmAgencyEntityBlock from '../Modal/ConfirmAgencyEntityBlock'

export default function ManagementAgencyEntity(props) {
    const location = useLocation();
    const [defaultFormValues, setDefaultFormValues] = useState({
        nome_orgao: "",
        nome_rede_atendimento: "",
        status_orgao: ""
    });
    const [stateMsg, setStateMsg] = useState();
    const [newStatus, setNewStatus] = useState();
    let timeout = useRef(null) //Permite que o valor do temporizador persista entre as renderizações

    let statusOrgaoOptions =
    Object.entries(statusOrgaoEnum.getLabels)
        .filter(([key, value]) => key !== "getLabelByValue") // remove o método 'getLabelByValue'
        .map(([key, value]) => ({
            value: key,
            label: value
        }));
    statusOrgaoOptions.unshift({value: "TODOS", label: "Todos"})

    const [selectedOptionStatusOrgao, setSelectedOptionStatusOrgao] = useState(statusOrgaoOptions[0]);

    let agencyScopeOptions =
        Object.entries(agencyScopeEnum.getLabels)
            .filter(([key, value]) => key !== "getLabelByValue") // remove o método 'getLabelByValue'
            .map(([key, value]) => ({
                value: key,
                label: value
            }));
    agencyScopeOptions.unshift({value: "TODOS", label: "Todos"})

    const [selectedOptionAbrangencia, setSelectedOptionAbrangencia] = useState(agencyScopeOptions[0])
    const [estadosOptions, setEstadosOptions] = useState(estados);
    const [selectedOptionEstados, setSelectedOptionEstados] = useState()
    const [selectedOptionMunicipio, setSelectedOptionMunicipio] = useState()

    useEffect(() => {
            const { message, newStatus } = location.state || {}; // Desestruturar o estado recebido
            setStateMsg(message)
            setNewStatus(newStatus ? newStatus : props.newStatus)
            console.log('props.newStatus: ' + props.newStatus)
            location.state = {}
            //O prev => [ ...prev] é mais indicado do que [...estadosOptions] quando quiser garantir que está pegando o estado mais atualizado
            setEstadosOptions(prev => [
                { value: "TODOS", label: "Todos" },
                ...prev
            ])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.newStatus])

    useEffect(()=>{
        setSelectedOptionEstados(estadosOptions[0])
    }, [estadosOptions])

    useEffect(() => { //Submete a pesquisa 1 segundo após o termino do input
        clearTimeout(timeout.current);
        if ((defaultFormValues.nome_orgao.trim() !== "") || (defaultFormValues.nome_rede_atendimento.trim() !== "") || ((defaultFormValues.status_orgao.trim() !== "") && (defaultFormValues.status_orgao.trim() !== "TODOS"))){
            timeout.current = setTimeout(() => {
                document.getElementById('searchButton').click();
            }, 1000)
        }       
    }, [defaultFormValues])

    useEffect(() => {
        if (props.cleanFilter) cleanFields();
        props.setCleanFilter(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.cleanFilter])

    const cleanFields = () => {
        props.setSearchResult([]);
        setDefaultFormValues({...defaultFormValues, nome_orgao: '', nome_rede_atendimento: '', status_orgao: '', abrangencia: ''})
        document.getElementById('nomeOrgao').value = "";
        document.getElementById('nomePopularOrgao').value = "";
        setSelectedOptionStatusOrgao(statusOrgaoOptions[0]);
        setSelectedOptionAbrangencia(agencyScopeOptions[0]);
        props.setErroMsg(undefined);
    }
    
    const { handleSubmit, errors, control, reset } = useForm({ defaultFormValues });

    const rangePagesOptions = [
        { value: "10", label: "10" },
        { value: "20", label: "20" },
        { value: "30", label: "30" },
    ];
    
    // ESTILIZACAO PARA O SELECT ======================================================
    const SelecStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: state.isFocused ? 2.5 : 1,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': {
                backgroundColor: '#C5D4EB',
            },
            marginTop: 6,
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            fontSize: 13.5,
            fontWeight: 355,
            marginLeft: 7,
            fontStyle: 'italic',
        }),
    }
    const SelecPageStyles = {
        control: (defaultStyles, state) => ({
            ...defaultStyles,
            borderWidth: 0,
            borderColor: state.isFocused ? '#E60000' : '#888',
            '&:hover': {
                backgroundColor: '#C5D4EB',
            },
            marginTop: 15,
        }),
    }

    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                {props.selectProps.menuIsOpen 
                    ? <img src={DropUpIcon} alt="upicon" />
                    : <img src={DropDownIcon} alt="downicon"/>
                }
            </components.DropdownIndicator>
        );
    };

    const IndicatorSeparator = ({ innerProps }) => {
        return <span style={{}} {...innerProps} />;
    };
    // ================================================================================ 

    const [modalCancel, setModalCancel] = useState(false);

    return (
        <>
            <ModalCancel
                id="modalcancelalert"
                appear={modalCancel}
                text={"Deseja cancelar a pesquisa e retornar para página principal?"}
                actionButton1={() => setModalCancel(false)}
                actionButton2={() => props.history.push("/pesquisarcidadao")}
            />
            <ModalWarn
                id="modalconfirmalert"
                appear={props.modalError}
                text = {
                    'Houve algum problema no servidor. Aguarde um momento e tente novamente.'
                }
                textButton2='Ok'
                actionButton2={() => props.setModalError(false)}
            />
            <ModalConfirm
                id="modalconfirmUnblock"
                appear={props.isModalConfirmUnblockVisible}
                title={'Desbloquear rede de atendimento'}
                text={'Tem certeza que deseja desbloquear a rede de atendimento <b>' + props.selectedAgency.NOME_REDE_ATENDIMENTO + '</b>? <p>Essa ação restabelecerá o acesso de todos os usuários dessa rede ao sistema.</p>'}
                load={props.loadModalconfirmUnblock}
                textButton1="Cancelar"
                actionButton1={() => {props.setModalConfirmUnblockVisible(false); props.setSelectedAgency({});}}
                textButton2="Sim"
                actionButton2={(e) => { props.onSubmitUnblock(props.selectedAgency);}}
            />
            <ModalConfirmAgencyEntityBlock
                id="modalconfirmAgencyEntityBlock"
                appear={props.isModalConfirmAgencyEntityBlockVisible}
                title={'Bloquear rede de atendimento'}
                text={'Tem certeza de que deseja bloquear a rede de atendimento <b>' + props.selectedAgency.NOME_REDE_ATENDIMENTO + '</b> ? <p>Essa ação impedirá o acesso de todos os usuários dessa rede ao sistema.</p><p>É necessário informar o motivo do bloqueio.</p>'}
                setSelectedAgency={props.setSelectedAgency}
                textButton1="Não"
                actionButton1={() => {props.setModalConfirmAgencyEntityBlockVisible(false); props.setSelectedAgency({});}}
                textButton2="Sim"
                actionButton2={(e) => { props.setModalConfirmAgencyEntityBlockVisible(false); props.onSubmitAgencyEntityBlock(props.selectedAgency); }}
            />
            <ModalWarn
                id="modalWarningStatusChanged"
                appear={newStatus}
                text = {`O status do credenciamento da rede <b>${newStatus?.agencyName}</b> foi alterado para <b>${newStatus?.newStatus}</b>.`}
                textButton2='Ok'
                actionButton2={() => {setNewStatus(undefined)}}
            />

            <GlobalContainer>
                {stateMsg &&
                    <MessageSuccess text={stateMsg}/>
                }
                {props.successMsg &&
                    <MessageSuccess text={props.successMsg}/>
                }
                <ContentContainer>
                    <TitleContainer>
                        <Title>{props.pageTitle}</Title>
                        <button className="br-button primary" onClick={() => props.history.push(props.buttonRegistrationRoute)}>
                            {props.buttonRegistrationTitle}
                        </button>
                    </TitleContainer>

                    <Subtitle>
                        <img
                            src={FilterIcon}
                            alt="filterIcon"
                            style={{ "marginBottom": "7px", "marginRight": "7px" }}
                        />
                        <label> Filtro </label>
                        <Line />
                    </Subtitle>

                    <form onSubmit={handleSubmit(() => {setStateMsg(undefined); props.onSubmitSearch(defaultFormValues);})}>
                        <SearchContainer>
                            <InputContainer>
                                <div className="br-input">
                                    <label htmlFor="nomePopularOrgao"> Nome da rede de atendimento </label>
                                    <input style={{"width": "300px"}}
                                        id="nomePopularOrgao"
                                        name="nomePopularOrgao"
                                        type="text"
                                        placeholder={props.fieldNamePlaceholder2}
                                        defaultValue={defaultFormValues.nome_rede_atendimento}
                                        onChange={(event) => {
                                            const { value } = event.target
                                            setDefaultFormValues({ ...defaultFormValues, nome_rede_atendimento: value })
                                            props.setSearchResult([]);
                                            props.setErroMsg(undefined);
                                        }}
                                    />
                                </div>
                                {errors?.nomePopularOrgao &&
                                    <span className="feedback danger" role="alert">
                                        <i className="fas fa-times-circle" aria-hidden="true">
                                            <img
                                                src={FailIcon}
                                                style={{ paddingBottom: '5px' }}
                                                alt="failicon"
                                            />
                                        </i>
                                        {errors.nomePopularOrgao.message}
                                    </span>}
                            </InputContainer>
                            <InputContainer>
                                <div className="br-input">
                                    <label htmlFor="nomeOrgao"> Nome do órgão/entidade responsável </label>
                                    <input style={{"width": "300px"}}
                                        id="nomeOrgao"
                                        name="nomeOrgao"
                                        type="text"
                                        placeholder={props.fieldNamePlaceholder}
                                        defaultValue={defaultFormValues.nome_orgao}
                                        onChange={(event) => {
                                            const { value } = event.target
                                            setDefaultFormValues({ ...defaultFormValues, nome_orgao: value })
                                            props.setSearchResult([]);
                                            props.setErroMsg(undefined);
                                        }}
                                    />
                                </div>
                                {errors?.nomeOrgao &&
                                    <span className="feedback danger" role="alert">
                                        <i className="fas fa-times-circle" aria-hidden="true">
                                            <img
                                                src={FailIcon}
                                                style={{ paddingBottom: '5px' }}
                                                alt="failicon"
                                            />
                                        </i>
                                        {errors.nomeOrgao.message}
                                    </span>}
                            </InputContainer>       
                            <SelectContainer>                                
                                <label> Status </label>
                                <Controller
                                    name="statusOrgao"
                                    control={control}
                                    render={
                                        (e) => (
                                            <Select
                                                onChange={(value) => {
                                                    setSelectedOptionStatusOrgao(value);
                                                    setDefaultFormValues({ ...defaultFormValues, status_orgao: value.value });
                                                    reset();
                                                    props.setSearchResult([]);
                                                    props.setErroMsg(undefined);
                                                }}
                                                options={statusOrgaoOptions}
                                                value={selectedOptionStatusOrgao}
                                                placeholder="Selecione o status"
                                                styles={SelecStyles}
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: 6,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#CCCCCC',
                                                        primary: '#1351B4'
                                                    },
                                                })}
                                                components={
                                                    { DropdownIndicator, IndicatorSeparator }
                                                }
                                            />
                                        )
                                    }
                                />                                
                                {errors?.statusOrgao &&
                                    <span className="feedback danger" role="alert" id="statusOrgaoresult">
                                        <i className="fas fa-times-circle" aria-hidden="true">
                                            <img
                                                src={FailIcon}
                                                style={{ paddingBottom: '5px' }}
                                                alt="failicon"
                                            />
                                        </i>
                                        {errors.statusOrgao.message}
                                    </span>}
                            </SelectContainer>      
                            <SelectContainer>                                
                                <label> Abrangência </label>
                                <Controller
                                    name="abrangencia"
                                    control={control}
                                    render={
                                        (e) => (
                                            <Select
                                                onChange={(value) => {
                                                    setSelectedOptionAbrangencia(value);
                                                    setSelectedOptionEstados(estadosOptions[0]);
                                                    setSelectedOptionMunicipio(props.municipalityOptions[0]);
                                                    setDefaultFormValues({ ...defaultFormValues, abrangencia: value.value, uf: '', codigo_municipio: '' });
                                                    if (value.value === agencyScopeEnum.MUNICIPAL) {
                                                        props.listMunicipality();
                                                    }
                                                    reset();
                                                    props.setSearchResult([]);
                                                    props.setErroMsg(undefined);
                                                }}
                                                options={agencyScopeOptions}
                                                value={selectedOptionAbrangencia}
                                                placeholder="Selecione a abrangência"
                                                styles={SelecStyles}
                                                theme={theme => ({
                                                    ...theme,
                                                    borderRadius: 6,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: '#CCCCCC',
                                                        primary: '#1351B4'
                                                    },
                                                })}
                                                components={
                                                    { DropdownIndicator, IndicatorSeparator }
                                                }
                                            />
                                        )
                                    }
                                />                                
                                {errors?.abrangencia &&
                                    <span className="feedback danger" role="alert" id="abrangenciaresult">
                                        <i className="fas fa-times-circle" aria-hidden="true">
                                            <img
                                                src={FailIcon}
                                                style={{ paddingBottom: '5px' }}
                                                alt="failicon"
                                            />
                                        </i>
                                        {errors.abrangencia.message}
                                    </span>}
                            </SelectContainer>              
                        </SearchContainer>
                        { ((selectedOptionAbrangencia?.value === agencyScopeEnum.ESTADUAL) || (selectedOptionAbrangencia?.value === agencyScopeEnum.MUNICIPAL)) &&
                            <SearchContainer>
                                <SelectContainer>                                
                                    <label> Estado (UF) </label>
                                    <Controller
                                        name="estado"
                                        control={control}
                                        render={
                                            (e) => (
                                                <Select
                                                    onChange={(value) => {
                                                        setSelectedOptionEstados(value);
                                                        setSelectedOptionMunicipio(props.municipalityOptions[0]);
                                                        setDefaultFormValues({ ...defaultFormValues, uf: value.value, codigo_municipio: '' });
                                                        props.listMunicipality(value.value)
                                                        reset();
                                                        props.setSearchResult([]);
                                                        props.setErroMsg(undefined);
                                                    }}
                                                    isDisabled={props.loadingMunicipality}
                                                    options={estadosOptions}
                                                    value={selectedOptionEstados}
                                                    placeholder="Selecione o estado"
                                                    styles={SelecStyles}
                                                    theme={theme => ({
                                                        ...theme,
                                                        borderRadius: 6,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: '#CCCCCC',
                                                            primary: '#1351B4'
                                                        },
                                                    })}
                                                    components={
                                                        { DropdownIndicator, IndicatorSeparator }
                                                    }
                                                />
                                            )
                                        }
                                    />                                
                                    {errors?.estado &&
                                        <span className="feedback danger" role="alert" id="estadoresult">
                                            <i className="fas fa-times-circle" aria-hidden="true">
                                                <img
                                                    src={FailIcon}
                                                    style={{ paddingBottom: '5px' }}
                                                    alt="failicon"
                                                />
                                            </i>
                                            {errors.estado.message}
                                        </span>}
                                </SelectContainer> 
                                { (selectedOptionAbrangencia?.value === agencyScopeEnum.MUNICIPAL) &&
                                    <SelectContainer>                                
                                        <label> Município </label>
                                        { props.loadingMunicipality ? <span>carregando...</span>
                                            :
                                            <Controller
                                                name="municipio"
                                                control={control}
                                                render={
                                                    (e) => (
                                                        <Select
                                                            onChange={(value) => {
                                                                setSelectedOptionMunicipio(value);
                                                                setDefaultFormValues({ ...defaultFormValues, codigo_municipio: value.value });
                                                                reset();
                                                                props.setSearchResult([]);
                                                                props.setErroMsg(undefined);
                                                            }}
                                                            options={props.municipalityOptions}                                                        
                                                            value={selectedOptionMunicipio ? selectedOptionMunicipio : props.municipalityOptions[0]}
                                                            placeholder="Selecione o município"
                                                            styles={SelecStyles}
                                                            theme={theme => ({
                                                                ...theme,
                                                                borderRadius: 6,
                                                                colors: {
                                                                    ...theme.colors,
                                                                    primary25: '#CCCCCC',
                                                                    primary: '#1351B4'
                                                                },
                                                            })}
                                                            components={
                                                                { DropdownIndicator, IndicatorSeparator }
                                                            }
                                                        />
                                                    )
                                                }
                                            />  
                                        }                              
                                        {errors?.municipio &&
                                            <span className="feedback danger" role="alert" id="municipioresult">
                                                <i className="fas fa-times-circle" aria-hidden="true">
                                                    <img
                                                        src={FailIcon}
                                                        style={{ paddingBottom: '5px' }}
                                                        alt="failicon"
                                                    />
                                                </i>
                                                {errors.municipio.message}
                                            </span>}
                                    </SelectContainer> 
                                }
                            </SearchContainer>
                        }
                        
                        <SearchButtonsContainer>
                            <button className="br-button secundary" type="button"
                                onClick={() => setModalCancel(true)}>
                                Cancelar
                            </button>
                            <button className="br-button secondary" type="button"
                                onClick={() => { cleanFields() }}>
                                Limpar Filtro
                            </button>
                            {!props.buttonNextLoading ?
                                <button id='searchButton' className="br-button primary" type="submit">
                                    Pesquisar
                                </button> 
                            :
                                <button id='searchButton' className="br-button primary loading" type="button">
                                    Pesquisar
                                </button>
                            }
                        </SearchButtonsContainer>

                        <Subtitle>
                            <Line />
                        </Subtitle>
                    </form>

                    {!!props.searchResult.length && <>
                        <Subtitle>
                            <label>{props.tableResultListTitle}</label>
                        </Subtitle>
                        <div className="br-table" data-search="data-search" data-selection="data-selection">
                            <table style={{'tableLayout': 'fixed', 'width': '100%', 'borderCollapse': 'collapse'}}>
                                <thead>
                                    <tr>
                                        <th scope="col1" style={{ 'color': '#1351B4', 'width': '25%' }}> Rede de atendimento </th>
                                        <th scope="col2" style={{ 'color': '#1351B4', 'width': '25%' }}> Órgão/Entidade responsável </th>
                                        <th scope="col3" style={{ 'color': '#1351B4', 'width': '12%' }}> Abrangência </th>
                                        <th scope="col4" style={{ 'color': '#1351B4', 'width': '12%' }}> Status </th>
                                        <th scope="col5" style={{ 'color': '#1351B4', 'width': '12%' }}> Data de Credenciamento </th>
                                        <th scope="col8" style={{ 'color': '#1351B4', 'width': '14%' }}> Ações </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {props.searchResult.map(result => (
                                        <tr key={result.CODIGO_ORGAO}>
                                            <td style={{'overflowWrap': 'anywhere', 'wordBreak': 'breakWord', 'whiteSpace': 'normal'}}> {result.NOME_REDE_ATENDIMENTO ? result.NOME_REDE_ATENDIMENTO : '-'}</td>
                                            <td style={{'overflowWrap': 'anywhere', 'wordBreak': 'breakWord', 'whiteSpace': 'normal'}}> {result.NOME_ORGAO} </td>
                                            <td> {result.ABRANGENCIA ? ( result.ABRANGENCIA === agencyScopeEnum.NACIONAL ? agencyScopeEnum.getLabelByValue(result.ABRANGENCIA) : (agencyScopeEnum.getLabelByValue(result.ABRANGENCIA) + ' (' + (result.NOME_MUNICIPIO ? result.NOME_MUNICIPIO +'/' : '') + result.UF + ')') ) : '-'} </td>
                                            <td> {result.STATUS_ORGAO ? statusOrgaoEnum.getLabelByValue(result.STATUS_ORGAO) : '-'}</td>
                                            <td> {result.DATA_CREDENCIAMENTO ? formatDateDDMMYYYY(result.DATA_CREDENCIAMENTO) : '-'}</td>

                                            <td style={{width: "130px"}}>
                                                <img
                                                    src={ViewIcon}
                                                    alt="viewIcon"
                                                    title="Detalhar"
                                                    style={{
                                                        'marginRight': '15px',
                                                        'cursor': 'pointer'
                                                    }}
                                                    onClick={() => {
                                                        const data = {
                                                            result_search: result,
                                                            pagination: {
                                                                range_page: props.rangePages,
                                                                page: props.page,
                                                                page_options: props.pageOptions,
                                                                total: props.totalFilter
                                                            },
                                                            list: props.searchResult
                                                        }
                                                        props.history.push(props.buttonDetailRoute, data);
                                                    }}
                                                />
                                                {((result.STATUS_ORGAO === statusOrgaoEnum.CREDENCIADO) || (result.STATUS_ORGAO === statusOrgaoEnum.EM_CREDENCIAMENTO)) &&
                                                    <img
                                                        src={EditIcon}
                                                        alt="editIcon"
                                                        title="Editar"
                                                        style={{
                                                            'marginRight': '10px',
                                                            'cursor': 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            const data = {
                                                                result_search: result,
                                                                pagination: {
                                                                    range_page: props.rangePages,
                                                                    page: props.page,
                                                                    page_options: props.pageOptions,
                                                                    total: props.totalFilter
                                                                },
                                                                list: props.searchResult
                                                            }
                                                            props.history.push(props.buttonEditRoute, data);
                                                        }}
                                                    />
                                                }
                                                {(result.STATUS_ORGAO === statusOrgaoEnum.BLOQUEADO) &&
                                                    <img
                                                        src={UndoIcon}
                                                        alt="Desbloquear"
                                                        title="Desbloquear"
                                                        style={{
                                                            'marginRight': '10px',
                                                            'cursor': 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            props.setSuccessMsg(undefined);
                                                            props.setSelectedAgency(result);
                                                            props.setModalConfirmUnblockVisible(true);                                                           
                                                        }}
                                                    />
                                                }
                                                {(result.STATUS_ORGAO === statusOrgaoEnum.CREDENCIADO) &&
                                                    <img
                                                        src={DiscreditIcon}
                                                        alt="Bloquear"
                                                        title="Bloquear"
                                                        style={{
                                                            'marginRight': '10px',
                                                            'cursor': 'pointer'
                                                        }}
                                                        onClick={() => {
                                                            props.setSuccessMsg(undefined);
                                                            props.setSelectedAgency(result);
                                                            props.setModalConfirmAgencyEntityBlockVisible(true);     
                                                        }}
                                                    />
                                                }                                               
                                            </td>                                   
                                        </tr>
                                    )
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <PaginationContainer>
                            <nav className="br-pagination" aria-label="Paginação de resultados" data-total="50" data-current="1" data-per-page="20">
                                <div className="pagination-per-page">
                                    <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Exibir </label>
                                    <SelectPagesContainer>
                                        <Select
                                            options={rangePagesOptions}
                                            defaultValue={{ value: "10", label: "10" }}
                                            value={props.rangePages}
                                            onChange={value => {
                                                props.setRangePages(value)
                                                props.onChangePaginationConfig(defaultFormValues, value, props.page, true)
                                            }}
                                            styles={SelecPageStyles}
                                            theme={theme => ({
                                                ...theme,
                                                borderRadius: 6,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: '#CCCCCC',
                                                    primary: '#1351B4'
                                                },
                                            })}
                                            components={
                                                {
                                                    DropdownIndicator,
                                                    IndicatorSeparator
                                                }
                                            }
                                        />
                                    </SelectPagesContainer>
                                </div>

                                <span className="br-divider d-none d-sm-block mx-3"></span>

                                <div className="pagination-information d-none d-sm-flex">
                                    <span className="current"> {1 + ((Number(props.page.value) - 1) * Number(props.rangePages.value))} </span>&ndash;<span className="per-page"> {Number(props.page.value) * Number(props.rangePages.value)} </span>&nbsp;de&nbsp;<span className="total"> {props.totalFilter} </span>&nbsp;itens
                                </div>
                                <div className="pagination-go-to-page d-none d-sm-flex ml-auto">
                                    <label style={{ "fontWeight": "normal", "marginRight": "15px" }}> Página </label>
                                    <SelectPagesContainer>
                                        <Select
                                            options={props.pageOptions}
                                            defaultValue={{ value: "1", label: "1" }}
                                            value={props.page}
                                            onChange={value => {
                                                props.setPage(value)
                                                props.onChangePaginationConfig(defaultFormValues, props.rangePages, value, false)
                                            }}
                                            styles={SelecPageStyles}
                                            theme={theme => ({
                                                ...theme,
                                                borderRadius: 6,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: '#CCCCCC',
                                                    primary: '#1351B4'
                                                },
                                            })}
                                            components={
                                                {
                                                    DropdownIndicator,
                                                    IndicatorSeparator
                                                }
                                            }
                                        />
                                    </SelectPagesContainer>
                                </div>

                                <span className="br-divider d-none d-sm-block mx-3"></span>

                                <div className="pagination-arrows ml-auto ml-sm-0">
                                    <button className="br-button circle" type="button" aria-label="Voltar página"
                                        style={{
                                            'opacity': Number(props.page.value) > 1 ? '' : '0.4',
                                            'pointerEvents': Number(props.page.value) > 1 ? '' : 'none'
                                        }}
                                        onClick={() => {
                                            const new_page = {
                                                value: String(Number(props.page.value) - 1),
                                                label: String(Number(props.page.value) - 1)
                                            }
                                            props.setPage(new_page)
                                            props.onChangePaginationConfig(defaultFormValues, props.rangePages, new_page, false)
                                        }}
                                    >
                                        <i className="fas fa-angle-left" aria-hidden="true">
                                            <img
                                                src={DropLeftIcon}
                                                alt="leftIcon"
                                                style={{ "marginBottom": "6px" }}
                                            />
                                        </i>
                                    </button>
                                    <button className="br-button circle" type="button" aria-label="Avançar página"
                                        style={{
                                            'opacity': Number(props.page.value) < (Math.ceil(Number(props.totalFilter) / Number(props.rangePages.value))) ? '' : '0.4',
                                            'pointerEvents': Number(props.page.value) < (Math.ceil(Number(props.totalFilter) / Number(props.rangePages.value))) ? '' : 'none'
                                        }}
                                        onClick={() => {
                                            const new_page = {
                                                value: String(Number(props.page.value) + 1),
                                                label: String(Number(props.page.value) + 1)
                                            }
                                            props.setPage(new_page)
                                            props.onChangePaginationConfig(defaultFormValues, props.rangePages, new_page, false)
                                        }}
                                    >
                                        <i className="fas fa-angle-right" aria-hidden="true">
                                            <img
                                                src={DropRightIcon}
                                                alt="rightIcon"
                                                style={{ "marginBottom": "6px" }}
                                            />
                                        </i>
                                    </button>
                                </div>
                            </nav>
                        </PaginationContainer>
                    </>}

                    {
                        props.erroMsg &&
                            <span className="feedback warning" role="alert" id="listresult">
                                <i className="fas fa-times-circle" aria-hidden="true">
                                    <img
                                        src={AlertIcon}
                                        style={{ paddingBottom: '5px' }}
                                        alt="failicon"
                                    />
                                </i>
                                <label id="listresultlabel">{props.erroMsg}</label>
                            </span>
                    }
                </ContentContainer>
            </GlobalContainer>
        </>
    );
}